module.exports = __webpack_public_path__ + "img/item6.01182693.png";